import { Buildings, ArrowRight } from "@phosphor-icons/react"
import { useDivisions } from "../../hooks"
import { useUIStore } from "../../stores"
import { cn } from "../../lib/utils"
import type { Division } from "../../types"

const divisionColors: Record<string, string> = {
  Bankruptcy: "#2CC4E4",
  "Personal Injury": "#2dce89",
  "Family Law": "#fb6340",
  Immigration: "#8b5cf6",
}

function getDivisionColor(division: Division): string {
  return division.color || divisionColors[division.name] || "#2CC4E4"
}

export function NoDivisionSelected() {
  const { data: divisions = [], isLoading } = useDivisions()
  const setSelectedDivision = useUIStore((s) => s.setSelectedDivision)

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="w-full max-w-md text-center space-y-6">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary/10">
          <Buildings className="w-7 h-7 text-primary" weight="duotone" />
        </div>

        {/* Text */}
        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-foreground">Select a Division</h2>
          <p className="text-sm text-muted-foreground">
            Choose a division to get started. You can switch divisions at any time from the header.
          </p>
        </div>

        {/* Division cards */}
        {isLoading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary" />
          </div>
        ) : (
          <div className="space-y-2">
            {divisions.map((division) => {
              const color = getDivisionColor(division)
              return (
                <button
                  key={division._id}
                  onClick={() => setSelectedDivision(division._id)}
                  className={cn(
                    "flex w-full items-center gap-3 px-4 py-3 rounded-lg",
                    "bg-card border border-border",
                    "text-left text-sm font-medium text-foreground",
                    "transition-all duration-150",
                    "hover:border-primary/30 hover:shadow-sm hover:bg-accent"
                  )}
                >
                  <span
                    className="h-3 w-3 shrink-0 rounded-full"
                    style={{
                      backgroundColor: color,
                      boxShadow: `0 0 0 2px ${color}20`,
                    }}
                  />
                  <span className="flex-1">{division.name}</span>
                  <ArrowRight className="h-4 w-4 text-muted-foreground" />
                </button>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
